module.exports = __webpack_public_path__ + "img/fdjicon.a649e6a7.svg";